import React from 'react';

import classes from './PanelHeader.module.css';

const PanelHeader = props => {

    return (
        <h2 className={classes.PanelHeader}>
            {props.url && <img src={props.url} alt={props.title} />}
            <span>{props.title}</span>
        </h2>
    );
};

export default PanelHeader;
